import React from 'react';
import { useLocation } from 'react-router-dom';

const HeaderNewTabButton = () => {
  const location = useLocation();

  if (!location.pathname.startsWith('/user/')) {
    return null;
  }

  const openCurrentPage = () => {
    window.open(window.location.href, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      type="button"
      className="header-new-tab-button"
      onClick={openCurrentPage}
      aria-label="Open this page in a new tab"
      title="Open this page in a new tab"
    >
      <svg className="header-new-tab-icon" aria-hidden="true" focusable="false" viewBox="0 0 20 20">
        <path d="M8 5H5.75A1.75 1.75 0 0 0 4 6.75v7.5C4 15.22 4.78 16 5.75 16h7.5c.97 0 1.75-.78 1.75-1.75V12" />
        <path d="M11 4h5v5" />
        <path d="m10 10 6-6" />
      </svg>
    </button>
  );
};

export default HeaderNewTabButton;
